import { render } from "./Approaches.vue?vue&type=template&id=73a47801"
import script from "./Approaches.vue?vue&type=script&lang=js"
export * from "./Approaches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__